<div class="row row-cols-1 row-cols-lg-2">
    <div class="col ">
      <div
        class="fw-bold bg-white p-3 rounded-5 mb-5 shadow"
        *ngIf="permissionsService.createPermission"
      >
        <!-- Primera fila -->
        <div class="d-flex justify-content-between">
          <div>
            <label for="information" class="labelInformation">{{
              informationFile
            }}</label>
          </div>
        </div>
  
        <!-- Segunda fila -->
        <div class="row row-gap-3">
          <div class="mb-3">
            <input
              class="form-control"
              type="file"
              id="formFileImport"
              (change)="onFileSelected($event)"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              [class.is-invalid]="massImportInvalidSims.length > 0"
            />
            <div class="invalid-feedback">
              We found some issues in your data. Download the spreadsheet to view and correct the specific errors 
              <button  (click)="downloadthisMassImportInvalidSims()" type="button" class="btn btn-outline-danger btn-sm"><i class="bi bi-download"></i></button>
            </div>
            <small *ngIf="fileError" class="text-danger">
              Only CSV or Excel files are allowed.
            </small>
          </div>
        </div>
  
        <!-- Tercera fila - Botón de descarga -->
        <div class="row">
          <div class="col text-start">
            <button class="btn btn-secondary" (click)="downloadTemplate()">
              <i class="bi bi-download"></i> Download Template
            </button>
          </div>
          <div class="col text-end">
            <button
              class="btn btn-primary w-100 w-md-auto"
              [disabled]="!fieldImportCompleted"
              (click)="importSims()"
            >
              Import SIMs (CSV)
            </button>
          </div>
        </div>
        </div>
  
        
    </div>
  
    <div class="col">
      <div
        class="fw-bold bg-white p-3 rounded-5 mb-5 shadow"
        *ngIf="permissionsService.createPermission"
      >
        <!-- Primera fila -->
        <div class="d-flex justify-content-between">
          <div>
            <label for="information" class="labelInformation">{{
              informationFileUpdate
            }}</label>
          </div>
        </div>
  
        <!-- Segunda fila -->
        <div class="row row-gap-3">
          <div class="mb-3">
            <input
              class="form-control"
              type="file"
              id="formFileUpdate"
              (change)="onFileSelectedUpdate($event)"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              [class.is-invalid]="massUpdateInvalidSims.length > 0"
            />

            <div class="invalid-feedback">
              We found some issues in your data. Download the spreadsheet to view and correct the specific errors 
              <button  (click)="downloadMassUpdateInvalidSims()" type="button" class="btn btn-outline-danger btn-sm"><i class="bi bi-download"></i></button>
            </div>
            <!-- <small *ngIf="fileError" class="text-danger">
              Only CSV or Excel files are allowed.
            </small> -->
          </div>
        </div>
  
        <!-- Tercera fila - Botón de descarga -->
        <div class="row">
          <div class="col text-start">
            <button class="btn btn-secondary" (click)="downloadTemplate('update')">
              <i class="bi bi-download"></i> Download Template
            </button>
          </div>
          <div class="col text-end">
            <button
              class="btn btn-primary w-100 w-md-auto"
              [disabled]="!fieldUpdateCompleted"
              (click)="updateSims()"
            >
              Update SIMs (CSV)
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>